import {  UserProfileTab } from './types';

export const UserPronouns = [
  {
    label: 'None Selected',
    value: 'NONE_SELECTED',
  },
  {
    label: 'she/her',
    value: 'HER',
  },
  {
    label: 'he/him',
    value: 'HIM',
  },
  {
    label: 'they/them',
    value: 'THEM',
  },
  {
    label: 'ze/hir',
    value: 'HIR',
  },
  {
    label: 'ze/zir',
    value: 'ZIR',
  },
  {
    label: 'she/they',
    value: 'SHE_THEY',
  },
  {
    label: 'he/they',
    value: 'HE_THEY',
  },
];

export const ProfileTab: UserProfileTab = {
  hash: 'profile',
  label: 'PROFILE',
};

export const AppointmentsTab: UserProfileTab = {
  hash: 'appointments',
  label: 'APPOINTMENTS',
};

export const DocumentsTab: UserProfileTab = {
  hash: 'documents',
  label: 'DOCUMENTS',
};

export const OnboardingTab: UserProfileTab = {
  hash: 'onboarding',
  label: 'ONBOARDING',
};